<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">
      Annuaire
    </div>
    <div class="modal-body">
      <div class="search-part">
        <form (ngSubmit)="doSearchRecipients()">
          <span class="inputs-column">
            <frg-form-input
              label="Nom d'exercice"
              id="exerciceName"
              type="text"
              [formGroup]="formGroup"
              [control]="formGroup.get('exerciceName')"
            ></frg-form-input>

            <frg-form-input
              label="Prénom usuel"
              id="firstName"
              type="text"
              [formGroup]="formGroup"
              [control]="formGroup.get('firstName')"
            ></frg-form-input>

            <frg-form-input
              label="Profession"
              id="professionSpeciality"
              type="text"
              [formGroup]="formGroup"
              [control]="formGroup.get('professionSpeciality')"
            ></frg-form-input>
          </span>

          <span class="inputs-column">
            <frg-form-input
              label="Code postal"
              id="zip"
              type="text"
              [formGroup]="formGroup"
              [control]="formGroup.get('zip')"
            ></frg-form-input>

            <frg-form-input
              label="Ville"
              id="city"
              type="text"
              [formGroup]="formGroup"
              [control]="formGroup.get('city')"
            ></frg-form-input>
          </span>
        </form>

        <div class="button-wrapper" *ngIf="formGroup">
          <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
          <frg-button backgroundColor="var(--primary)" (activated)="doSearchRecipients()" [disabled]="!formGroup.valid">Rechercher</frg-button>
          <div class="alert-troncated-result" *ngIf="result && result.result.length > 0 && result.troncated"
            title="Seuls les 100 premiers résultats peuvents être affichés."
          >
            <div>Nombre de résultats important</div>
            <div>Utilisez les filtres pour affiner votre recherche</div>
          </div>
        </div>
      </div>

      <div class="result-part" *ngIf="isSearching || noSearchYet || (result && result.result.length > 0)">
        <div class="loading" *ngIf="isSearching">
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="result" *ngIf="!isSearching">
          <div class="no-result" *ngIf="!result || result.result.length === 0">
            Aucun résultat
          </div>

          <div class="search-result" *ngIf="result && result.result.length > 0">
            <frg-table
              [keysBody]="recipientsTable"
              [keysColumn]="recipientsTableColumnTable"
              [isRowsClickable]="true"
              (onClickRow)="selectRecipient($event)"
              (onChangePage)="changePage($event)"
            ></frg-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>